import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Updates Hands-Free Trail Exploration for Millions of Members" />,
  date: 'September 26, 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Updates Hands-Free Trail Exploration for Millions of Members" />
      </Typography>
      <Typography variant="paragraph100">
        <FormattedMessage defaultMessage="San Francisco (September 26, 2024) — AllTrails, the world's largest and most popular platform for outdoor exploration, today announced updates to its Apple Watch app experience, bringing new features to the wrists of millions of trailgoers." />
        <br />
        <FormattedMessage defaultMessage="With AllTrails on Apple Watch, members can:" />
        <ul>
          <li>
            <FormattedMessage defaultMessage="Stay on trail with a new compass feature for navigational guidance." />
          </li>
          <li>
            <FormattedMessage defaultMessage="Track their activity stats including time spent on trail, pace, heart rate, distance remaining, and elevation, all on their watch in real-time." />
          </li>
          <li>
            <FormattedMessage defaultMessage="Integrate their AllTrails activity with Apple Health." />
          </li>
        </ul>
        <br />
        <FormattedMessage defaultMessage="AllTrails+ members also receive wrong-turn watch alerts if they veer off route." />
        <br />
        <FormattedMessage defaultMessage="The Apple Watch update enhances AllTrails’ suite of watch experiences, which also includes AllTrails on Android watches  and Garmin integrations. AllTrails’ wearables apps maintain a connection between phone and watch so that members can tuck their phone into a pocket or backpack for a hands-free trail experience." />
        <br />
        <FormattedMessage defaultMessage="“AllTrails exists to help the world find its way outside, and we know many of our members explore the outdoors with a wearable device,” said Ivan Selin, chief product officer at AllTrails. “Now there’s no need to reach for your phone while taking in the views or holding your dog’s leash. We built our Apple Watch app to make it easier than ever to explore the outdoors hands-free.”" />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your outside with inspiration from a global community of trailgoers. We connect people to the outdoors, help them discover new places, and elevate their experiences on the trail. AllTrails was awarded Apple’s 2023 iPhone App of the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn more."
          values={{ allTrailsDotComLink }}
        />
      </Typography>
    </>
  )
};

export default pressRelease;
